import React, { useMemo } from "react";
import * as THREE from "three";
import { SmokeScene } from "react-smoke";

const FogOverlay = () => {
  const smokeColor = useMemo(() => new THREE.Color("#e8e4d9"), []);

  return (
    <div
      className="absolute inset-0 z-[3] pointer-events-none overflow-hidden mix-blend-screen hidden 2xl:block"
      style={{ top: "0" }}
    >
      <SmokeScene
        resize={{
          scroll: false,
          debounce: {
            resize: false,
            scroll: false,
          },
        }}
        smoke={{
          opacity: 0.2,
          color: smokeColor,
          density: 8,
          enableRotation: true,
          rotation: [0, 0, 0.2],
        }}
      />
    </div>
  );
};

export default FogOverlay